import Class from './c-content-chart-radius-pie-for-budget';
import './c-content-chart-radius-pie-for-budget@.vue';

export default Class;